import {
  GetFileMediaParams,
  GetFileMediaResponse,
  UploadFileParams,
  UploadParams,
} from "~/types/media/media.types";

import { sendRequest } from "../clients/axios";

const getFileMedia = ({ fileName, isPublic, path }: GetFileMediaParams) => {
  try {
    const slugifyFileName = fileName
      .normalize("NFD")
      .toLocaleLowerCase()
      .replace(/\s/g, "")
      .replace(/[\u0300-\u036f]/g, "");

    return sendRequest<UploadParams, GetFileMediaResponse>({
      method: "post",
      url: `/media/get-upload-path/${slugifyFileName}`,
      data: {
        isPublic,
        path,
      },
    });
  } catch (error) {
    throw error;
  }
};

export const uploadFile = async ({
  file,
  isPublic,
  path,
}: UploadFileParams) => {
  const fileName = file.name;

  try {
    const res = await getFileMedia({
      fileName,
      isPublic,
      path,
    });
    fetch(res.data.url, { method: "put", body: file });
    return res.data.path;
  } catch (e) {
    throw e;
  }
};
